import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import nossaLoader from '../../vendors/nossa';
import { SessionContext } from '../StoreProvider';
import { LOG } from '../../helpers';
import { assign as navigate } from '../../routes';
import Text from '../../components/atoms/text';
import Subtitle from '../../components/atoms/subtitle';

import './style.scss';

const CreateUser = ({ user, getUserData }) => {
  useEffect(() => {
    if (!window.nossaContainer) {
      window.nossaContainer = nossaLoader(
        { getUserData },
        { route: 'cadastro' }
      );
      window.nossaContainer.init();
    }
  }, []); // eslint-disable-line

  useEffect(() => {
    if (user && !user.userData.cpf_cnpj) {
      LOG('[USER]', user);
      navigate('/confirmar-cpf');
    } else if (user && user.userInfo.subscriber) {
      LOG('[USER]', user);
      navigate('/usuario-assinante');
    } else if (user) {
      navigate('/ativacao');
    }
  }, [user]);

  return (
    <>
      <div className="create-header">
        <Subtitle>Crie sua conta e comece seu teste grátis de GZH.</Subtitle>
        <Text>
          Sem cadastrar cartão de crédito, sem compromisso de assinar.
        </Text>
      </div>
      <div className="identify-container" />
    </>
  );
};

CreateUser.defaultProps = {
  user: {}
};

CreateUser.propTypes = {
  user: PropTypes.shape({
    userInfo: PropTypes.object,
    userData: PropTypes.object,
    cpf_cnpj: PropTypes.string
  }),
  getUserData: PropTypes.func.isRequired
};

export default props => (
  <CreateUser {...useContext(SessionContext)} {...props} />
);
